<div class="stripe-wrapper">
  <div class="payment-card shadow-lg p-6 bg-white rounded-xl border border-gray-100">
    <div class="card-header border-b pb-4 mb-6">
      <h3 class="text-xl font-semibold text-gray-800 flex items-center gap-2">
        <i class="material-icons text-blue-600">payment</i>
        Secure Credit/Debit Card
      </h3>
      <p class="text-sm text-gray-500">Your payment information is encrypted and secure.</p>
    </div>

    <!-- Stripe Card Element Container -->
    <div class="stripe-element-container mb-6">
      <div id="card-element"
        class="p-4 border rounded-lg bg-gray-50 focus-within:ring-2 focus-within:ring-blue-500 transition-all duration-200">
        <!-- A Stripe Element will be inserted here. -->
      </div>
      <!-- Used to display Element errors. -->
      <div id="card-errors" role="alert" class="mt-2 text-sm text-red-500 font-medium h-5"></div>
    </div>

    <div class="action-footer flex items-center justify-between mt-8 pt-6 border-t">
      <div class="stripe-branding">
        <img src="assets/images/logo/2.png" alt="Stripe" class="h-6 opacity-60">
      </div>
      <button [attr.guide]="'stripe-btn-1' + '__' + sanitizeUrl(url)" [disabled]="disable" (click)="makePayment()"
        class="pay-now-btn flex items-center gap-2 py-3 px-8 rounded-full font-bold text-white transition-all transform active:scale-95 shadow-lg"
        [class.loading]="loading">
        <span *ngIf="!loading">PAY NOW {{currencySymbol}}{{finalAmount}}</span>
        <span *ngIf="loading" class="flex items-center gap-2">
          Processing...
        </span>
      </button>
    </div>
  </div>
</div>